import React, {memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type SnailItemContainerProps = {
    containerRef?: React.RefObject<HTMLLIElement>
    isActive: boolean
    hijackClick: (event: React.MouseEvent) => void
    hijackMouseEnter: (event: React.MouseEvent) => void
    hijackMouseLeave: () => void
    marketingStyles: {linkColour?: string; fontWeight?: string}
    testId: string
    className: string
    index: number
    pin?: string
    mapping?: string
    hidden: boolean
    title: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    children: React.ReactNode
}

const SnailItemContainer = memo((props: SnailItemContainerProps) => {
    const {templating, ...restProps} = props
    const TemplatedContainer = useTemplatedComponent(templating, MANIFEST)

    return <TemplatedContainer {...restProps} />
})
SnailItemContainer.displayName = "SnailItemContainer"

export default connect(SnailItemContainer)
